import { All, HTTPMethod } from '../../types/enums';
import BaseAdapter from './baseAdapter';
import { AdapterInterface } from '../../types/global';
import { CategoricalData, HeadlineCardGraphRequest } from '../../api-models';

export default class PostHeadlineCardGraph extends BaseAdapter<CategoricalData[]> implements AdapterInterface {
  rawResponse: CategoricalData[];

  modifiedRequest: HeadlineCardGraphRequest;

  async adaptResponse(request: { snapshot: string, liftDataId: string , wardName: string, headlineTitle: string }): Promise<CategoricalData[]> {
    await this.fetchApiResponse('/api/card/headline/graph', HTTPMethod.Post, this.adaptRequest(request));
    return this.rawResponse;
  }

  adaptRequest(request: { snapshot: string, liftDataId: string , wardName: string, headlineTitle: string }): HeadlineCardGraphRequest {
    const liftDataId = request.liftDataId === String(All.value) ? null : Number(request.liftDataId);
    this.modifiedRequest = {
      snapshot: request.snapshot,
      lift_data_id: liftDataId,
      ward_name: request.wardName,
      headline_title: request.headlineTitle,
    };

    return this.modifiedRequest;
  }
}
